
export default function NoImageSectionCard({title, blurb, primaryButtonRow, shouldRemovePatternWrap=false}) {

    return (
        <div>
            <div className={`${shouldRemovePatternWrap ? "": "bg-pattern-bottom bg-pattern _none"} mt-12`}>
                <div className="container">
                    <div id="tours" className="layout row layout-builder__layout">
                        <div className="col-12 mb-4 mt-4">
                            <div
                                className="_none block block-layout-builder block-inline-blockixm-blocks-accordion ixm-blocks--accordion my-2"
                                id="inline-blockixm-blocks-accordioninline_block:ixm_blocks_accordion">

                                <div className="">
                                    <h2 className="mb-5 text-center fw-normal text-6xl">
                                        {title}
                                    </h2>
                                    <div className=" text-center w-100 w-lg-75 mx-auto space-y-4 mb-12">
                                        <div>
                                            {blurb}
                                        </div>
                                        <div>
                                            {primaryButtonRow}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}